/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
function createActionLink(name, action, provider) {
    return action
        ? tslib_1.__assign({ className: "m-navigation-link-" + name, text: action.text, href: action.url }, ((provider && provider(name, action)) || {})) : undefined;
}
function mapFromAccountSwitchDataV1(options) {
    var serviceUnavailable = false; // normally, the service is available
    var data = options.data;
    var noAccount = data.noAccount, nonValidatedAccount = data.nonValidatedAccount, person = data.person, labels = data.labels;
    var activeApiAccount = (data.accountData || []).find(function (data) { return data.id === options.activeAccountId; });
    var actions = activeApiAccount
        ? activeApiAccount.actions
        : noAccount.actions;
    var accounts = (data.accountData || []).map(mapToAccount);
    var activeAccount = findActiveAccount(accounts, options.activeAccountId);
    var toplevelMenuEntries = mapToplevelMenuEntries(options, activeAccount);
    var mobilePersonalMenuEntries = (activeApiAccount
        ? activeApiAccount.mobilePersonalMenuEntries
        : noAccount.mobilePersonalMenuEntries).map(function (entry) { return mapMenuEntry(options, entry); });
    return {
        serviceUnavailable: serviceUnavailable,
        person: {
            userName: person.name
        },
        activeAccount: activeAccount,
        accounts: accounts,
        /* eventHandlers */
        onClick: function (active) {
            return active
                ? options.onOpen && options.onOpen()
                : options.onClose && options.onClose();
        },
        onRequestClose: function () { return (options.onClose ? options.onClose() : undefined); },
        onSwitchStart: function (newAccount) {
            return options.onSwitchStart && options.onSwitchStart(newAccount.id);
        },
        onSwitchFinish: function (newAccount) {
            return options.onSwitchFinish && options.onSwitchFinish(newAccount.id);
        },
        /* Navigation */
        actions: {
            addExistingCard: createActionLink("addExistingCard", actions.addExistingCard, options.actionPropsProvider),
            registerNewAccount: createActionLink("registerNewAccount", actions.registerNewAccount, options.actionPropsProvider),
            joinAccount: createActionLink("joinAccount", actions.joinAccount, options.actionPropsProvider),
            profileAndSettings: createActionLink("profileAndSettings", actions.profileAndSettings, options.actionPropsProvider),
            logout: createActionLink("logout", {
                text: labels.logout.text,
                url: options.logoutActionUrl
            }, options.actionPropsProvider),
            findNearestStore: createActionLink("findNearestStore", actions.findNearestStore, options.actionPropsProvider)
        },
        labels: {
            addAccount: {
                text: labels.addAccount.text
            },
            switchAccount: {
                text: labels.switchAccount.text
            },
            back: {
                text: labels.back.text
            }
        },
        toplevelMenuEntries: toplevelMenuEntries,
        mobilePersonalMenuEntries: mobilePersonalMenuEntries,
        serviceUnavailableContent: serviceUnavailable ? (React.createElement("div", { className: "serviceUnavailableContent" }, "Service Unavailable")) : null,
        noAccountContent: noAccount ? (React.createElement("div", { className: "noAccountContent" },
            React.createElement("h3", null, noAccount.headline),
            React.createElement("p", null, noAccount.text))) : null,
        nonValidatedAccountContent: nonValidatedAccount ? (React.createElement("div", null,
            React.createElement("h3", null, nonValidatedAccount.headline),
            React.createElement("p", null, nonValidatedAccount.text))) : null
    };
}
exports.mapFromAccountSwitchDataV1 = mapFromAccountSwitchDataV1;
function mapToAccount(data) {
    return {
        id: data.id,
        companyName: data.corporateName,
        abbreviation: data.abbreviation,
        color: data.color,
        address: data.legalAddress,
        validated: data.validated
    };
}
function findActiveAccount(accounts, activeAccountId) {
    if (!activeAccountId) {
        return undefined;
    }
    return accounts.find(function (account) { return account.id === activeAccountId; });
}
function mapToplevelMenuEntries(options, activeBackendAccount) {
    if (activeBackendAccount) {
        var activeAccount = options.data.accountData.find(function (account) { return account.id === activeBackendAccount.id; });
        if (activeAccount.menuEntries) {
            return activeAccount.menuEntries.map(function (entry) {
                return mapMenuEntry(options, entry);
            });
        }
    }
    return [];
}
function mapMenuEntry(options, menuEntry) {
    var customProps = options.menuEntryPropsProvider && options.menuEntryPropsProvider(menuEntry);
    return tslib_1.__assign({ text: menuEntry.text, href: menuEntry.url }, (customProps || {}));
}